(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('productGallery', (mediaCount) => ({
      isDesktop: window.matchMedia('(min-width: 990px)').matches,
      mediaCount: mediaCount,
      main: null,
      thumbnails: null,
      currentActiveVideo: null,
      mediaQuery: null,
      boundBreakpointHandler: null,

      init() {
        if (typeof Splide === 'undefined') return;
        this.initSliders();

        this.mediaQuery = window.matchMedia('(min-width: 990px)');
        this.boundBreakpointHandler = (e) => this.handleBreakpointChange(e.matches);
        this.mediaQuery.addEventListener('change', this.boundBreakpointHandler);
      },

      destroy() {
        if (this.mediaQuery && this.boundBreakpointHandler) {
          this.mediaQuery.removeEventListener('change', this.boundBreakpointHandler);
        }
        this.destroySliders();
      },

      handleBreakpointChange(isDesktop) {
        if (this.isDesktop !== isDesktop) {
          this.isDesktop = isDesktop;
          this.$nextTick(() => {
            this.destroySliders();
            this.initSliders();
          });
        }
      },

      destroySliders() {
        const DESTROYED = 7;
        if (this.main && !this.main.state.is(DESTROYED)) this.main.destroy();
        if (this.thumbnails && !this.thumbnails.state.is(DESTROYED)) this.thumbnails.destroy();
        this.main = null;
        this.thumbnails = null;
        this.currentActiveVideo = null;
      },

      initSliders() {
        const mainEl = this.$el.querySelector('#main-slider');
        const thumbEl = this.$el.querySelector('#thumbnail-slider');
        if (!mainEl) return;

        this.main = new Splide(mainEl, {
          pagination: false,
          arrows: this.mediaCount > 1,
          rewind: true,
          lazyLoad: 'nearby',
          preloadPages: 2,
          keyboard: 'global',
          focus: 'center',
        });

        if (thumbEl && this.mediaCount > 1) {
          const baseConfig = {
            rewind: true,
            pagination: false,
            isNavigation: true,
            arrows: false,
            waitForTransition: true,
          };

          const thumbConfig = this.isDesktop
            ? { ...baseConfig, direction: 'ttb', height: '40rem', perPage: 5, gap: 5, focus: 'center' }
            : {
                ...baseConfig,
                direction: 'ltr',
                fixedWidth: '5.6rem',
                fixedHeight: '5.6rem',
                gap: '0.5rem',
                focus: 0,
              };

          this.thumbnails = new Splide(thumbEl, thumbConfig);
          this.main.sync(this.thumbnails);
        }

        this.main.mount();
        if (this.thumbnails) this.thumbnails.mount();
        this.setupVideoControls();
      },

      setupVideoControls() {
        const handleVideoControl = () => {
          const activeSlide = this.$el.querySelector('#main-slider .splide__slide.is-active');
          const activeVideo = activeSlide?.querySelector('video');

          if (this.currentActiveVideo && this.currentActiveVideo !== activeVideo) {
            this.currentActiveVideo.pause();
          }

          if (activeVideo) activeVideo.play().catch(() => {});
          this.currentActiveVideo = activeVideo;
        };

        this.main.on('moved', handleVideoControl);
        this.main.on('mounted', handleVideoControl);
      },
    }));
  });

  window.initializeProductGallery = function () {
    const gallery = document.querySelector('[x-data*="productGallery"]');
    if (gallery?._x_dataStack) {
      const data = gallery._x_dataStack[0];
      if (data?.destroySliders && data?.initSliders) {
        data.destroySliders();
        data.initSliders();
      }
    }
  };
  } catch(e) { console.error(e); }
})();

})();
